//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class SendTransactionReceiptInputItem extends ItemBase {
    RecipientParentID: string | null = null;
    SendEmailMessage: boolean = false;
    UseEmailTemplateSubjectAndBody: boolean = false;
    EmailSubject: string | null = null;
    EmailBody: string | null = null;
    BCCEmailToTeacher: boolean = false;
    SendSMSMessage: boolean = false;
    UseSMSTemplateBody: boolean = false;
    SMSBody: string | null = null;

    constructor(initializer?: Partial<SendTransactionReceiptInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SendTransactionReceiptInputItem";
}
